import React from 'react'

import cx from 'classnames'

import { UserAvatar } from '@driftt/dds'

import './style.css'

interface IProps {
  user: {
    name?: string
    email?: string
    availability?: string
    avatarUrl?: string
  }
  team?: string
  fallbackName?: string
  hideAvatar?: boolean
}

const UserCell = ({
  user = {},
  fallbackName = 'Your teammate',
  hideAvatar,
}: IProps) => (
  <div className="user-cell">
    {!hideAvatar && (
      <UserAvatar name={user.name} size={'small'} imageUrl={user.avatarUrl} />
    )}
    <span
      data-private
      className={cx('user-cell-name--no-avatar', {
        'user-cell-name': !hideAvatar,
      })}
    >
      {user.name || user.email || fallbackName}
    </span>
  </div>
)

const UserCellWithTeam = ({
  user = {},
  team,
  fallbackName = 'Your teammate',
  hideAvatar,
}: IProps) => {
  const isOnline = user.availability === 'AVAILABLE'
  return (
    <div className={cx('user-cell', 'user-cell-with-team')}>
      {!hideAvatar && (
        <UserAvatar
          name={user.name}
          status={isOnline ? 'available' : 'away'}
          size={'small'}
          imageUrl={user.avatarUrl}
        />
      )}
      <span
        data-private
        className={cx('user-cell-name--no-avatar', {
          'user-cell-name': !hideAvatar,
        })}
      >
        {user.name || user.email || fallbackName}
        {team && (
          <>
            <br />
            <span className="user-team-name">{team}</span>
          </>
        )}
      </span>
    </div>
  )
}

const UserCellWithAvailability = ({
  user = {},
  fallbackName = 'Your teammate',
  hideAvatar,
}: IProps) => {
  const isOnline = user.availability
  return (
    <div className="user-cell">
      {!hideAvatar && (
        <UserAvatar
          name={user.name}
          status={isOnline ? 'available' : 'away'}
          size={'small'}
          imageUrl={user.avatarUrl}
        />
      )}
      <span
        data-private
        className={cx('user-cell-name--no-avatar', {
          'user-cell-name': !hideAvatar,
        })}
      >
        {user.name || user.email || fallbackName}
      </span>
    </div>
  )
}

export const renderUserCell = (
  user,
  fallbackName?: string,
  hideAvatar?: boolean,
  team?
) =>
  team ? (
    <UserCellWithTeam
      user={user}
      team={team}
      fallbackName={fallbackName}
      hideAvatar={hideAvatar}
    />
  ) : (
    <UserCell
      user={user}
      team={team}
      fallbackName={fallbackName}
      hideAvatar={hideAvatar}
    />
  )

export const renderUserCellWithAvailability = (
  user,
  fallbackName?: string,
  hideAvatar?: boolean
) => (
  <UserCellWithAvailability
    user={user}
    fallbackName={fallbackName}
    hideAvatar={hideAvatar}
  />
)

export default UserCell
